import { Injectable } from "@angular/core";
import { of } from "rxjs";
import * as _ from "lodash";
import {
  AuditLogRecord,
  AuditLogRecordCoordinates,
  AuditLogRecordAddress,
  AuditLogRecordUnits,
  AuditLogRecordUpdate,
} from "../Models/read";
import { LoaderService } from "./loader.service";
import { HttpService } from "../http.service";
import { APIEndpoints } from "src/config/apiEndpoint.config";

@Injectable({
  providedIn: "root",
})
export class AuditLogService {
  constructor(private readonly httpService: HttpService) {}

  async getAuditLogRecords(surveyId: string): Promise<AuditLogRecord[]> {
    const logs = await this.httpService
      .get<any[]>(APIEndpoints.auditLogs(surveyId))
      .toPromise();
    return logs.map((log) => {
      const payload = log.payload || {};

      return {
        id: log.id,
        type: log.type,
        address: payload.address,
        date: new Date(log.executedOn),
        executedByUser: log.executedByUser,
        executedBy: log.executedBy,
        validatorRemark: payload.validatorRemark,
        coordinates: payload.coordinates,
        payload,
        units: payload.units,
        outsideSurvey: payload.outsideSurvey,
        engineer: payload.engineer,
        buildingGroup: payload.buildingGroup,
        person: payload.person,
        facade: payload.facade,
        lomKey: payload.lomKey,
        lamKey: payload.lamKey,
      };
    });
  }
}
